import { useCallback } from 'react';

import useBaseURL from 'hooks/useBaseURL';
import { PATTERN_QUESTION_IMAGE, PATTERN_QUESTION_URL } from 'constant';

/**
 * Replacer.
 */
export default function useReplacer() {
  const path = useBaseURL();

  const replaceExamText = useCallback(
    /**
     * @param {String} text
     * @returns {String}
     */
    (text) => {
      // Replace [@url] dengan questionImage path.
      let newText = text.replace(
        PATTERN_QUESTION_IMAGE,
        `${path.questionImage}p/`
      );

      // Replace [@url] dengan questionImage path.
      newText = newText.replace(
        PATTERN_QUESTION_URL,
        `${path.questionImage}p/`
      );

      return newText;
    },
    [path.questionImage]
  );

  return {
    examText: replaceExamText,
  };
}
